<template>
    <div class="login">
        <div class="header">
            <div class="con">
                <div class="header-left">
                    <img src="/static/login-logo.png" alt="">
                </div>
                <div class="header-right">
                    <img src="" alt="">
                </div>
            </div>
        </div>

        <div class="container">
            <div class="loginmain">
                <div>
                    <a-tabs default-active-key="1" @change="callback">
                        <a-tab-pane key="1" tab="账号密码登录">
                            <a-input ref="userNameInput" v-model="username" placeholder="请输入登录账号">
                                <a-icon slot="prefix" type="user" />
                            </a-input>
                            <a-input ref="userNameInput" type="password" v-model="password" placeholder="请输入登录密码">
                                <a-icon slot="prefix" type="lock" />
                            </a-input>

                            <a-button type="primary" @click="login" block style="margin-top:48px">
                            登录
                            </a-button>
                        </a-tab-pane>
                        <!-- <a-tab-pane key="2" tab="手机号登录">
                            <a-input ref="userNameInput" v-model="phone" placeholder="请输入手机号">
                                <a-icon slot="prefix" type="user" />
                            </a-input>
                            <a-input-search class="code" v-model="code" placeholder="验证码"  @search="getcode">
                                <a-icon slot="prefix" type="mail" />
                                <a-button slot="enterButton" :size="size">
                                    {{codetext}}
                                </a-button>
                            </a-input-search>
                            <a-button type="primary" @click="codelogin" block style="margin-top:48px">
                            登录
                            </a-button>
                        </a-tab-pane> -->
                    </a-tabs>
                </div>
            </div>
        </div>

        <div class="bottomcpi">
            <p>本系统由 阿里云 提供技术支持</p>
            <p>Copyright © 2020 苏州万橡志恒网络科技有限公司 <a href="https://beian.miit.gov.cn" target="_blank">苏ICP备13036725号-8</a></p>
        </div>
    </div>
</template>

<style>

.bottomcpi{
    color: #fff;
    position: absolute;
    bottom: 16px;left: 50%;
    transform: translateX(-50%);
    font-size: 13px;
    line-height: 18px;
    text-align: center;
    z-index: 999;
}
.bottomcpi a{color: #fff}
</style>

<script>
export default {
    data(){
        return{
            size:'small',
            username:'',
            password:'',
            phone:"",
            code:"",
            codetext:"获取验证码"
        }
    },
    methods:{
        callback(key) {
          
        },
        getcode(){
            var phone=this.phone
            if(phone==""){
                Toast('请输入号码');
            }else if(!phone.match(/^[1][3,4,5,6,7,8,9][0-9]{9}$/)){
                Toast('请输入正确的号码格式');
            }else{
                 //倒计时
                let time = 60;
                let timer = setInterval(() => {
                if(time == 0) {
                    clearInterval(timer);
                    // this.disabled = false;
                    this.codetext = "获取验证码";
                } else {
                    this.codetext =time + '秒后重试';
                    // this.disabled = true;
                    time--
                }
                },1000)
                var params=new URLSearchParams()
                params.append('phone',phone)
                params.append('type',2)
                this.$axios.post('/api/getSmsNew',params,
                {
                headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    
                }
                }).then((res)=>{
                    if(res.data.code==200){
                        Toast(res.data.msg);
                    }else{
                        Toast(res.data.msg);
                    }
                });
            }
        },
        login(){
            var params=new URLSearchParams()
            params.append('username',this.username)
            params.append('password',this.password)
            this.$axios.post('/api/login',params,{
                headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.$router.push({ path:'/home/main'  })
                    localStorage.setItem('token', res.data.data.token);
                }else{
                    this.$message.error(res.data.msg);
                }
            })
        },
        codelogin(){
            var params=new URLSearchParams()
            params.append('username',this.phone)
            params.append('code',this.code)
            this.$axios.post('/api/smslogin',params,
            {
            headers: {
                "appid": this.appSet.appid,
                "appkey": this.appSet.appkey,
            }
            }).then((res)=>{
                console.log(res);
                if(res.data.code==200){
                    localStorage.setItem('token', res.data.data.token);
                    this.$router.push({path: '/home/main'})
                }else{
                    Toast(res.data.msg)
                }
               
            });
        }
    }
    
}
</script>




// WEBPACK FOOTER //
// src/components/login.vue